module.exports = __webpack_public_path__ + "media/images/btn_quicksearch-34ab33f594d5f05e160b31581fe12a4d.gif";